import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import ListItemWithMovieContainer from './ListItemWithMovieContainer'
import { HIGHLIGHT } from '../../../constants/itemTypes'
import { PROGRAM_HIGHLIGHTS } from '../../../constants/state'
import getData from '../../../functions/getData'
import ListItemNoDataContainer from './ListItemNoDataContainer'

const mapStateToProps = (state, ownProps) => ({
    itemData:  getData(state, [PROGRAM_HIGHLIGHTS, ownProps.itemId])
})

const ListItemDataHighlightContainer = ({
    itemId,
    itemData,
    additionalClass =  false,
    isSelected = false,
    pathnameEdit = false,
    onDeleteItem = false
}) => {

    if(!itemData) {
        return <ListItemNoDataContainer onDelete={() => onDeleteItem(itemId)} />
    } else {
        return <ListItemWithMovieContainer
            itemType={HIGHLIGHT}
            itemData={itemData}
            additionalClass={additionalClass}
            isSelected={isSelected}
            pathnameEdit={pathnameEdit}
            onDelete={() => onDeleteItem(itemId)}
        />
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemDataHighlightContainer)